import { Newsletter } from './Newsletter'

export default Newsletter
